import { useEffect } from 'react';

// Closes an open popover when the user presses outside of `ref`. Uses a
// capture-phase listener so it still fires when the clicked target (e.g. the
// header report-filter ReactSelects) calls stopPropagation on mousedown, which
// would otherwise swallow a bubble-phase document listener.
export default function useCloseOnOutsideClick(ref, onClose, isActive = true) {
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    function handle(evt) {
      if (ref.current && !ref.current.contains(evt.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handle, true);
    document.addEventListener('touchstart', handle, true);
    return () => {
      document.removeEventListener('mousedown', handle, true);
      document.removeEventListener('touchstart', handle, true);
    };
  }, [ref, onClose, isActive]);
}
